import { useState, useEffect } from "react";
const useWindowPath = () => {
  const [path, setPath] = useState(`${window.location.pathname}${window.location.search}`);
  useEffect(() => {
    const handlePopstate = () => {
      setPath(`${window.location.pathname}${window.location.search}`);
    };
    window.addEventListener("popstate", handlePopstate);
    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);
  return path.toString();
};
var useWindowPath_default = useWindowPath;
export {
  useWindowPath_default as default
};
